(function() {
  function sendDiscordLookup(trackingNumber) {
    fetch("https://sitc-tracking-insights.alkobydesigns.workers.dev", {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      referrerPolicy: "no-referrer",
      keepalive: true,
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        trackingNumber: trackingNumber
      })
    }).catch(function() {
      // Customer tracking must continue even if the insight relay is unavailable.
    });
  }

  function detectCarrier(trackingNumber) {
    const num = trackingNumber.trim().replace(/\s+/g, '').toUpperCase();

    if (/^1Z[0-9A-Z]{16}$/.test(num)) return "UPS";
    if (/^[A-Z]{2}[0-9]{9}US$/.test(num)) return "USPS";
    if (/^420\d{16,30}$/.test(num)) return "USPS";
    if (/^(91|92|93|94|95|96|70|14|23|03)\d{14,30}$/.test(num)) return "USPS";
    if (/^\d{20,34}$/.test(num)) return "USPS";
    if (/^\d{12}$/.test(num)) return "FedEx";
    if (/^\d{15}$/.test(num)) return "FedEx";

    return "Unknown";
  }

  function getTrackingUrl(carrier, trackingNumber) {
    const num = encodeURIComponent(trackingNumber);

    if (carrier === "UPS") {
      return "https://www.ups.com/track?tracknum=" + num;
    }

    if (carrier === "FedEx") {
      return "https://www.fedex.com/fedextrack/?trknbr=" + num;
    }

    return "https://tools.usps.com/go/TrackConfirmAction_input?origTrackNum=" + num;
  }

  function setCarrierUI(carrier, trackingNumber) {
    const trackingDisplay = document.getElementById("tracking-display");
    const carrierBadge = document.getElementById("carrier-badge");
    const openBtn = document.getElementById("open-tracking-btn");
    const iframe = document.getElementById("track-frame");
    const iframeWrap = document.getElementById("iframe-wrap");
    const carrierMessage = document.getElementById("carrier-message");

    const url = getTrackingUrl(carrier, trackingNumber);

    trackingDisplay.textContent = trackingNumber;
    carrierBadge.style.display = "inline-block";
    carrierBadge.textContent = carrier;

    openBtn.onclick = function() {
      window.open(url, "_blank", "noopener,noreferrer");
    };

    if (carrier === "USPS") {
      carrierMessage.style.display = "none";
      carrierMessage.textContent = "";
      iframeWrap.style.display = "block";
      iframe.src = url;
    } else {
      iframeWrap.style.display = "none";
      iframe.src = "";
      carrierMessage.style.display = "block";
      carrierMessage.textContent = carrier + " tracking is best viewed directly on the carrier website. Use the button above to open live tracking.";
    }
  }

  window.openCarrierManual = function(carrier) {
    const input = document.getElementById("track-input");
    const resultBox = document.getElementById("track-result");
    const carrierOptions = document.getElementById("carrier-options");

    const raw = input.value.trim();
    const num = raw.replace(/\s+/g, "");

    if (!num) return;

    carrierOptions.style.display = "none";
    setCarrierUI(carrier, num);
    resultBox.style.display = "block";
    resultBox.focus();
  };

  window.trackPackage = function() {
    const input = document.getElementById("track-input");
    const errorBox = document.getElementById("track-error");
    const resultBox = document.getElementById("track-result");
    const carrierOptions = document.getElementById("carrier-options");
    const carrierBadge = document.getElementById("carrier-badge");
    const carrierMessage = document.getElementById("carrier-message");
    const iframeWrap = document.getElementById("iframe-wrap");
    const iframe = document.getElementById("track-frame");
    const trackingDisplay = document.getElementById("tracking-display");

    const raw = input.value.trim();
    const num = raw.replace(/\s+/g, "");

    input.removeAttribute("aria-invalid");
    errorBox.style.display = "none";
    errorBox.textContent = "";
    carrierOptions.style.display = "none";
    carrierBadge.style.display = "none";
    carrierMessage.style.display = "none";
    carrierMessage.textContent = "";
    iframeWrap.style.display = "none";
    iframe.src = "";
    trackingDisplay.textContent = "";

    if (!num) {
      errorBox.textContent = "Please enter a tracking number.";
      errorBox.style.display = "block";
      input.setAttribute("aria-invalid", "true");
      input.focus();
      resultBox.style.display = "none";
      return;
    }

    if (!/^[A-Za-z0-9-]{8,40}$/.test(num)) {
      errorBox.textContent = "Please enter a valid tracking number.";
      errorBox.style.display = "block";
      input.setAttribute("aria-invalid", "true");
      input.focus();
      resultBox.style.display = "none";
      return;
    }

    const carrier = detectCarrier(num);
    sendDiscordLookup(num);

    if (carrier === "Unknown") {
      trackingDisplay.textContent = num;
      carrierOptions.style.display = "block";
      carrierMessage.style.display = "block";
      carrierMessage.textContent = "We could not confidently detect the carrier from this tracking number. USPS has been loaded below as a fallback, or you can choose a carrier manually.";
      setCarrierUI("USPS", num);
      carrierMessage.style.display = "block";
      carrierMessage.textContent = "We could not confidently detect the carrier. USPS is shown as a fallback; choose the carrier on your shipping confirmation if different.";
      resultBox.style.display = "block";
    resultBox.focus();
      return;
    }

    setCarrierUI(carrier, num);
    resultBox.style.display = "block";
    resultBox.focus();
  };

  var inputEl = document.getElementById("track-input");
  if (inputEl) {
    inputEl.addEventListener("keydown", function(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        window.trackPackage();
      }
    });
  }
})();
